/* eslint no-param-reassign: 0 */

export const updatePincode = ($, payload) => {
  $.cart.pincode = payload;
};

// TODO: secure rental with a similar methods. Didnt have the time to do it.
export const updateCampaignCode = ($, payload) => {
  $.cart.pincode = payload.pincode;
  $.cart.campaignCode = payload.campaignCode;
  $.cart.codeRequiresExtraInfo = payload.codeRequiresExtraInfo;
  $.cart.codeExtraInfo = payload.codeExtraInfo;

  // eslint-disable-next-line
  for (let i in payload.skipasses) {
    try {
      $.cart.skipasses[i].discountedPrice =
        payload.skipasses[i].discountedPrice;
      $.cart.skipasses[i].discountedPrices =
        payload.skipasses[i].discountedPrices;
    } catch (e) {
      console.log(e);
    }
  }
  // eslint-enable

  // eslint-disable-next-line
  const rentalProductTypes = ['products', 'addons'];

  // eslint-disable-next-line
  for (let i in payload.rentals) {
    // eslint-disable-next-line
    for (let iTyp in rentalProductTypes) {
      const typ = rentalProductTypes[iTyp];
      // eslint-disable-next-line
      for (let ii in payload.rentals[i][typ]) {
        try {
          $.cart.rentals[i][typ][ii].discountedPrice =
            payload.rentals[i][typ][ii].discountedPrice;
        } catch (e) {
          console.log(e);
        }
      }
    }
  }
  // eslint-enable
};

export const updateCampaignCodeExtraInfo = ($, payload) => {
  $.cart.codeExtraInfo = payload.codeExtraInfo;
};

export const updateUserDetails = ($, payload) => {
  console.log(payload);
  $.cart.email = payload.email;
  $.cart.phone = payload.phone.toString().replaceAll(' ', '').replaceAll('-', '');
  $.cart.name = payload.name;
  $.cart.lastName = payload.lastName;
  // $.cart.notes = payload.notes;
};

export default 'bar';



// WEBPACK FOOTER //
// ./src/store-methods/mutations/booking.js